import { render, staticRenderFns } from "./Departamento.vue?vue&type=template&id=2ba0766a"
import script from "./Departamento.vue?vue&type=script&lang=js"
export * from "./Departamento.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports